<script>
	export default {
		name: 'SupplierExecuter',
		computed: {
			serverDataSupplieresolve() {
				return true
			}
		}
	}
</script>